// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"cZ-z","subtitle":"dZ-z","wrapper":"eZ-z","leftArrow":"fZ-z","rightArrow":"gZ-z"};